<template>
    <div>
        <loading
            :active.sync="loading.app"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{ name: 'account' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Info Profil</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" v-if="loading.app == false">
            <div class="section inset mt-2">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Nama Lengkap</label>
                        <input
                            type="text"
                            class="form-control text-capitalize"
                            v-model="dataCustomerDetail.fullname"
                            style="font-size:13px;"
                        />
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Tanggal Lahir</label>
                        <div class="row">
                            <div class="col-4">
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="dataCustomerDetail.birthDay"
                                    placeholder="Tanggal"
                                    style="font-size:13px;padding: 0px 16px;"
                                />
                            </div>
                            <div class="col-4">
                                <select
                                    name=""
                                    class="form-control"
                                    v-model="dataCustomerDetail.birthMonth"
                                    style="font-size:13px;padding:0px 15px 0px 10px;"
                                >
                                    <option value="" disabled selected
                                        >- Bulan -</option
                                    >
                                    <option value="01">Januari</option>
                                    <option value="02">Februari</option>
                                    <option value="03">Maret</option>
                                    <option value="04">April</option>
                                    <option value="05">Mei</option>
                                    <option value="06">Juni</option>
                                    <option value="07">Juli</option>
                                    <option value="08">Agustus</option>
                                    <option value="09">September</option>
                                    <option value="10">Oktober</option>
                                    <option value="11">November</option>
                                    <option value="12">Desember</option>
                                </select>
                            </div>
                            <div class="col-4">
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="dataCustomerDetail.birthYear"
                                    placeholder="Tahun"
                                    style="font-size:13px;padding: 0px 16px;"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Jenis Kelamin</label>
                        <div class="row">
                            <div class="col-6">
                                <div class="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        id="genderMale"
                                        name="gender"
                                        class="custom-control-input"
                                        v-model="dataCustomerDetail.gender"
                                        value="L"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="genderMale"
                                        style="font-size:13px;"
                                        >Laki-Laki</label
                                    >
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        id="genderFemale"
                                        name="gender"
                                        class="custom-control-input"
                                        v-model="dataCustomerDetail.gender"
                                        value="P"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="genderFemale"
                                        style="font-size:13px;"
                                        >Perempuan</label
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Agama</label>

                        <select
                            name=""
                            class="form-control"
                            v-model="dataCustomerDetail.religion"
                            style="font-size:13px;padding:0px 15px 0px 10px;"
                        >
                            <option value="" disabled selected
                                >- Pilih Agama -</option
                            >
                            <option value="Islam">Islam</option>
                            <option value="Kristen">Kristen</option>
                            <option value="Katolik">Katolik</option>
                            <option value="Hindu">Hindu</option>
                            <option value="Budha">Budha</option>
                            <option value="Konghucu">Konghucu</option>
                            <option value="Lainnya">Lainnya</option>
                        </select>
                    </div>
                </div>
                <div class="form-group boxed">
                    <label class="label">Kecamatan Domisili</label>
                    <div class="transactions">
                        <!-- item -->
                        <a
                            href="javascript:;"
                            class="item"
                            :class="this.districts.data == 0 ? 'disabled' : ''"
                            style="padding: 10px"
                            @click="modalOptionDistricts('show')"
                        >
                            <div class="detail">
                                <div style="color: #17273e;">
                                    <b
                                        style="font-size:16px;margin-top:5px;margin-bottom: 5px;"
                                        >{{
                                            district_selected.district_name
                                        }}</b
                                    >
                                    <footer
                                        style="font-size:12px;line-height: 1.3;color:#726d79;margin-top: 5px;"
                                    >
                                        {{
                                            district_selected.regencie_province
                                        }}
                                    </footer>
                                </div>
                            </div>

                            <div class="right">
                                <div class="icon">
                                    <ion-icon name="chevron-down"></ion-icon>
                                </div>
                            </div>
                        </a>
                        <!-- * item -->
                    </div>
                </div>
                <div class="form-group basic">
                    <button
                        class="btn btn-primary btn-block btn-lg"
                        @click="showDialog('show')"
                    >
                        Simpan
                    </button>
                </div>
            </div>
        </div>

        <Dialog
            ref="dialog"
            :loading="dialogLoading"
            :title="'Simpan'"
            @confirm="submit()"
        >
            <p>Anda yakin akan merubah informasi profil?</p>
        </Dialog>

        <!-- Modal Opsi Metode Transfer -->
        <action-sheet
            ref="option_districts"
            :title="'Pilih Kecamatan'"
            :inset="false"
            :content-full="true"
            :contentHeight="false"
            :fullDisplay="true"
        >
            <div class="section mt-1">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Cari Kecamatan"
                            v-model="districts.keywords"
                        />
                        <i class="clear-input" @click="clearKeywordsDistricts">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                </div>
            </div>
            <ul
                class="listview image-listview"
                v-if="filterDistricts.length > 0"
            >
                <li v-for="item in filterDistricts" :key="item.district_code">
                    <a
                        style="cursor:pointer;"
                        class="item"
                        @click="selectDistrict(item)"
                    >
                        <div class="in">
                            <div>
                                <b>{{ item.district_name }}</b>
                                <footer>
                                    {{ item.regencies.regencie_name }}
                                    {{ item.regencies.provinces.province_name }}
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="text-center" v-else>
                <img
                    :src="require('@/assets/image/empty.webp')"
                    alt="404"
                    class="w-75"
                /><br />
                <h2 class="mb-0">Cari Kecamatan</h2>
                <p>Ayo masukkan pencarian lokasi kecamatan terlebih dahulu!</p>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import $axios from '../../api.js';
    export default {
        name: 'account.data-akun',
        data() {
            return {
                dialogLoading: false,
                dataCustomerDetail: {
                    fullname: '',
                    birthDay: '',
                    birthMonth: '',
                    birthYear: '',
                    gender: '',
                    religion: '',
                    districts_id: '',
                    districts_name: '',
                },
                districts: {
                    data: [],
                    keywords: '',
                },
                district_selected: {
                    district_name: '- Pilih Kecamatan -',
                    regencie_province: 'Kecamatan Domisili Anda',
                },
            };
        },
        created() {
            if (this.districtsAll.length > 0) {
                this.districts.data = this.districtsAll;
            }
            this.getCustomerDetail();
        },
        computed: {
            ...mapState(['customer', 'loading', 'toast', 'districtsAll']),
            filterDistricts: function() {
                if (!this.districts.keywords) return []; // Kembalikan data tanpa filter jika tidak ada keywords
                const regex = new RegExp(`(${this.districts.keywords})`, 'i');
                return this.districts.data.filter(item =>
                    regex.test(item.district_name)
                );
            },
        },
        methods: {
            clearKeywordsDistricts() {
                this.districts.keywords = '';
            },
            loadDistrictsSelected() {
                if (this.dataCustomerDetail.districts_name != '') {
                    const selectedDistrict = this.districts.data.find(
                        district =>
                            district.district_code ===
                            this.dataCustomerDetail.districts_id
                    );

                    if (selectedDistrict) {
                        this.district_selected.district_name =
                            selectedDistrict.district_name;
                        this.district_selected.regencie_province =
                            selectedDistrict.regencies.regencie_name +
                            ' ' +
                            selectedDistrict.regencies.provinces.province_name;
                    }
                }
            },
            showDialog(value) {
                let element = this.$refs.dialog.$el;
                window.$(element).modal(value);
            },
            getCustomerDetail() {
                console.log(this.customer);
                $axios.get('/customer/detail').then(response => {
                    if (
                        this.customer.account_verified &&
                        this.customer.account_verified_data.status !=
                            'APPROVED' &&
                        !this.customer.customer_detail
                    ) {
                        console.log(true);
                        this.dataCustomerDetail.fullname = this.customer.account_verified_data.full_name;
                        this.dataCustomerDetail.birthDay = this.customer.account_verified_data.birthdate.split(
                            '-'
                        )[2];
                        this.dataCustomerDetail.birthMonth = this.customer.account_verified_data.birthdate.split(
                            '-'
                        )[1];
                        this.dataCustomerDetail.birthYear = this.customer.account_verified_data.birthdate.split(
                            '-'
                        )[0];
                        this.dataCustomerDetail.gender = this.customer.account_verified_data.gender;
                    } else {
                        this.dataCustomerDetail = response.data.data;
                    }
                    this.loadDistrictsSelected();
                    this.$store.commit('SET_LOADING', { app: false });
                });
            },
            submit() {
                this.dialogLoading = true;
                $axios
                    .post('/customer/detail', this.dataCustomerDetail)
                    .then(response => {
                        this.showDialog('hide');
                        this.dialogLoading = false;
                        this.getCustomerDetail();
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: response.data.message,
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.showDialog('hide');
                        this.dialogLoading = false;
                    });
            },
            modalOptionDistricts(value) {
                this.districts.keywords = '';
                let element = this.$refs.option_districts.$el;
                window.$(element).modal(value);
            },
            selectDistrict(data) {
                this.dataCustomerDetail.districts_id = data.district_code;
                this.dataCustomerDetail.districts_name = data.district_name;
                this.district_selected.district_name = data.district_name;
                this.district_selected.regencie_province =
                    data.regencies.regencie_name +
                    ' ' +
                    data.regencies.provinces.province_name;

                this.modalOptionDistricts('hide');
            },
        },
        watch: {
            districtsAll: function(newValue) {
                if (newValue) {
                    this.districts.data = this.districtsAll;
                    this.loadDistrictsSelected();
                }
            },
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
